import { TAPIStatus } from '../api/ba-app.api';
import { TGRNStatus, TRollStatus } from '../input-app/fabric-inspection/api.types';
import { TOrganizi8AppDetails } from './common.types';
import { TMaterialRequestsAppDetails } from './material-requests.types';

export enum EGRNStatusValues {
  STARTED = 'STARTED',
  NOT_STARTED = 'NOT_STARTED',
  PASS = 'PASS',
  FAIL = 'FAIL',
}

export type TREQUEST_FabricStorageGRNDetails = {
  appDetails: TMaterialRequestsAppDetails;
  lotId: string;
};

export enum EGRNLotInspectionStatus {
  PASSED = 'PASSED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
}

export type TGRNDetailsDTO = {
  lotId: string;
  supplierName: string;
  supplierPo: string;
  grnStatus: EGRNLotInspectionStatus;
  grnNumber: string;
  length: number;
  itemCode: string;
  itemName: string;
  quantity: number;
  itemColor: string;
  lotStatus: EGRNLotInspectionStatus;
};

export type TRESPONSE_FabricStorageGRNDetails = {
  grnDetailsList: TGRNDetailsDTO[];
};

export type TREQUEST_TrimsStorageGRNDetails = TREQUEST_FabricStorageGRNDetails;

export type TRESPONSE_TrimsStorageGRNDetails = {
  grnDetails: TGRNDetailsDTO[];
};

export type TREQUEST_FabricStorageRollsDetails = {
  appDetails: TOrganizi8AppDetails;
  lotId: string;
  grnNumber: string;
  locationId: string;
  itemName: string;
  itemCode: string;
};

type TFabricRollsDetailsDTO = {
  baseRollId: string;
  rollNo: string;
  length: number;
  weight: number;
  width: number;
  actualLength: number;
  isStored: boolean;
  locationId?: string;
};

export type TRESPONSE_FabricStorageRollsDetails = {
  totalCapacity: number;
  rollInfoList: TFabricRollsDetailsDTO[];
};

export type TREQUEST_TrimsStorageItemDetails = {
  appDetails: TOrganizi8AppDetails;
  lotId: string;
  grnNumber: string;
  locationId: string;
  itemCode: string;
  itemName: string;
};

type TTrimsItemsDetailsDTO = {
  actual_qty: number;
  base_lot_id: string;
  factoryId: string;
  grn_number: string;
  grn_status: TGRNStatus;
  grn_tag_display_id: string;
  grn_tag_id: string;
  item_id: string;
  item_name: string;
  orderedQty: number;
  receivedQty: number;
  roll_status: TRollStatus;
  size: string;
  isStored: boolean;
  locationId?: string;
};

export type TRESPONSE_TrimsStorageItemDetails = {
  totalCapacity: number;
  rolls: TTrimsItemsDetailsDTO[];
};

export type TREQUEST_GetLocationDetails = {
  factoryId: string;
  userWarehouseId: string;
};

export type TRESPONSE_GetLocationDetails = {
  status: TAPIStatus;
  errorMessage: string | null;
  locationDto: {
    bay: string;
    shelf: string;
    bin: string;
    location_id: string;
    warehouse: string;
  };
};

type TAddFabricRollsToStorageDetailsDTO = {
  grnNumber: string;
  rollNo: string;
  length: number;
  itemColor: string;
  rollId: string;
};

export type TREQUEST_AddFabricRollsToStorage = {
  appDetails: TMaterialRequestsAppDetails;
  locationId: string;
  itemCode: string;
  fabricDetails: TAddFabricRollsToStorageDetailsDTO[];
};

export type TRESPONSE_AddFabricRollsToStorage = {
  status: 'SUCCESS' | 'ERROR';
  errors: string[];
};

type TAddTrimsItemsToStorageDetailsDTO = {
  grnNumber: string;
  qty: number;
  size: string;
};

export type TREQUEST_AddTrimItemsToStorage = {
  appDetails: TMaterialRequestsAppDetails;
  locationId: string;
  itemCode: string;
  itemColor: string;
  trimDetails: TAddTrimsItemsToStorageDetailsDTO[];
};

export type TRESPONSE_AddTrimItemsToStorage = TRESPONSE_AddFabricRollsToStorage;

export type TWarehouseDetailsPageState = {
  selectedGRNDetails: TGRNDetailsDTO;
  warehouseDetails: {
    location_id: string;
    warehouse: string;
    bay: string;
    bin: string;
    shelf: string;
  };
};
